import { REVIEW_INSTANT_FORMAT } from '@/app/document-review/review-labels'
import type { DocumentReviewDetailOutput } from '@/app/document-review/use-document-review'

export type PeopleNames = ReadonlyMap<number, string>

type Decided = Pick<DocumentReviewDetailOutput, 'reviewedBy' | 'reviewedAt' | 'step'>

export function deciderIdOf(detail: Pick<DocumentReviewDetailOutput, 'reviewedBy' | 'step'>): number | null {
  return detail.step === 'filedAutomatically' ? null : detail.reviewedBy
}

export function nameOf(names: PeopleNames, id: number | null): string | null {
  return id === null ? null : (names.get(id) ?? null)
}

function byWhom(lead: string, name: string | null): string {
  return name === null ? lead : `${lead} by ${name}`
}

export function decidedLine(decision: string, detail: Decided, names: PeopleNames): string {
  const who =
    detail.step === 'filedAutomatically'
      ? `${decision} automatically`
      : byWhom(decision, nameOf(names, deciderIdOf(detail)))
  return detail.reviewedAt === null ? who : `${who} · ${detail.reviewedAt.toString(REVIEW_INSTANT_FORMAT)}`
}
